import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "bootstrap/dist/js/bootstrap.bundle.min";

const StaticFaqs = () => {
  // Use an object to track which FAQ is open
  const [openFaqs, setOpenFaqs] = useState({});
  const [showMore, setShowMore] = useState(false);


  const handleFaq = (index) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the state for this particular FAQ
    }));
  };

  

  const faqsContent = [
    {
      question: "Why do people give corporate gifts?",
      answer: (
        <>
          <p className="fw-bold">
            Corporate gifts are given to employees and clients for a variety of
            reasons.
          </p>
          <p>
            <ul>
              <li>
                <b>Show appreciation</b>
                <br></br>
                Corporate gifts are a great way to show appreciation for your
                employees or clients. A thoughtful gift can show employees that
                their hard work is being noticed and appreciated leading them to
                be more productive
              </li>
              <li>
                <b>Increase motivation and loyalty</b> <br></br>
                It helps create a powerful influence on motivation and morale.
                It helps motivate employees and clients and increases their
                loyalty to the company. Gifting onboarding kits help new
                employees feel like they are part of the team.
              </li>
              <li>
                <b>Improve brand reputation</b> <br></br>
                Corporate gifting helps improves brand reputation since it
                demonstrates that the company genuinely cares about its
                employees, clients, and partners.
              </li>
            </ul>
          </p>
        </>
      ),
    },
    { question: "What is a joining kit?", 
        answer: "A joining kit or an employee welcome kit is a collection of items provided by an employer to welcome a new employee to an organization. It may include items such as an employee handbook, gifts, and other information about the organization and its culture." },
    {question: "What is the purpose of an onboarding kit?",
        answer:"An onboarding kit is given to new employees to help ensure that they have the resources and information they need to successfully transition into the new role. It also helps create a more positive environment for the new employee. Additionally, onboarding kits also help ensure that the new employee feels welcomed and appreciated from the start.",
    },
    {
        question: "What is in an onboarding kit?",
        answer:(
            <>
                <p>
                    An onboarding kit will usually consist of materials to help a new employee transition successfully such as:
                </p>
                <ul>
                    <li>
                    Employee handbook
                    </li>
                    <li>
                    Customized corporate gifts branded with the company logo
                    </li>
                    <li>
                        Welcome letter
                    </li>
                    <li>
                        List of contacts
                    </li>
                    <li>
                        List of benefits    
                    </li>
                </ul>
            </>
        ),
    },
    {
        question:"Why corporate gifting is important for business & how it benefits employee morale?",
        answer:"Corporate gifting is a unique way to identify your business with thoughtful and inventive gifts that can leave a lasting impression and also can significantly improve employee morale and motivation by providing tangible recognition and appreciation for their efforts in the form of incentives."
    },
    {
        question:"What are some popular and eco-friendly corporate gift ideas to consider?",
        answer:"Popular corporate gift ideas encompass tech gadgets, customized items, gift cards, gourmet treats, wellness products, custom apparel, desk accessories, books, etc. Whereas, eco-friendly corporate gift ideas include reusable water bottles, recycled notebooks, bamboo products, plantable seed paper, tote bags, upcycled items, and fair trade products like coffee or chocolates which are perfect for companies aiming to reduce their environmental impact and can also cater to various interests, showing appreciation for employees by contributing to a positive work culture."
    },
    {
        question:"What are some effective ways to select corporate gifts for staff and how they can be used as incentives for rewards & recognition?",
        answer:"For effective selection of corporate gifts for staff, consider theirs interests and company culture, set a reasonable budget, and proritize quality over quantity which can effectively serve as incentives for rewards & recognition program by celebrating their milestones, promoting healthy competition, and fostering a positive work culture where employees feel valued and appreciated."
    },
    {
        question:"What services do corporate gifting companies offer and how can they assit in creating unique and memorable experiences?",
        answer:"Corporate gifting companies like eYantra offer curated gift options, handle branding and packaging, manage logistics, assist with budget management, and offer personalized assistance to meet diverse gifting needs efficiently while creating unique and memorable experiences by offering customised gift options tailored to individuals' preferences and interests."
    },
    {
        question:"How can corporate gifts for employees improve employee satisfaction and loyalty while contributing to building a positive workplace?",
        answer:"Corporate gifts for employees improve satisfaction and loyalty by recognizing their contributions, promoting morale, and it helps to create a pleasant work environment by instilling a sense of satisfaction and camaraderie among employees which develops good atmosphere that will have a long-term influence on the entire company culture.",
    },
    {
        question:"What's included in welcome kits for new employees and how do they help integrate them into company culture as well as effective onboarding process?",
        answer:"Welcome kit for new employees is a great way to strengthen your company's corporate identity. With branded gear, such as notebooks, pens, mugs, or shirts, it not only makes the new employee feel like a member of the company, but it also acts as a covert marketing tool by creating a warm and welcoming environment, making people feel valued and appreciated from the start. It shows that the organization values its workers' experiences and is committed to providing the resources needed for a successful start."
    },
    {
        question:"What are some creative ideas for personalizing new hire welcome kits that supports the onboarding process?",
        answer:"Personalizing new hire welcome kits with handwritten notes, stickers, favorite snacks, local products, office plants, personalized stationery, etc fosters a positive first impression and sense of belonging from the start, making new hires feel valued and excited about joining the team that can also support the onboarding process by providing essential resources such as the employee handbook and technology setup instructions, facilitating connection with colleagues, fostering integration into company culture, and reducing stress for new employees."
    },
    {
        question:"What are some unique items of luxury corporate gifts and benefits of investing in them?",
        answer:"For luxury corporate gifts, you can choose unique items like customized leather accessories, artisanal food and beverage hampers, fine writing instruments, exclusive travel accessories, high-end tech gadgets, designer home décor, artisanal jewelry, personalized fine art, and exclusive experiences which make them memorable tokens of appreciation for valued clients, partners, or employees while promoting brand perceptions, foster stronger relationships, and enhance loyalty to differentiate the company, increase brand visibility, and open doors to new opportunities."
    },
    {
        question:"What sets unique corporate gifts apart from traditional options and how it helps in building strong relationships with clients and partners?",
        answer:"To distinguish from traditional options by their memorability, personalization, differentiation, etc, unique corporate gifts show thoughtfulness, evoke positive emotions, making them impactful choices for relationship-building by leaving a lasting impression, setting the company apart, developing emotional connections, and reinforcing the brand."
    }

  ];
  const faqsToShow = showMore ? faqsContent : faqsContent.slice(0, 5);

  return (
    <>
      <div className="mt-3">
        {faqsToShow.map((item, index) => (
          <div key={index}>
            <p
              className="p-3 rounded d-flex align-items-center justify-content-between fw-normal" 
              id="bgFaqs"
              onClick={() => handleFaq(index)}
            >
              {item.question}
              {openFaqs[index] ? (
                <Icon
                  icon="proicons:subtract"
                  width="24"
                  height="24"
                  style={{ color: "#fff" }}
                />
              ) : (
                <Icon
                  icon="proicons:add"
                  width="32"
                  height="32"
                  style={{ color: "#fff" }}
                />
              )}
            </p>
            {openFaqs[index] && <p className="m-2 pb-3">{item.answer}</p>}
          </div>
          
        ))}
        <button 
                onClick={() => setShowMore(prev => !prev)} 
                id="btnCTA"
            >
                {showMore ? 'View Less' : 'View More'}
            </button>
      </div>
      
    </>
  );
};

export default StaticFaqs;
